<template lang="html">
    <div class="modal modal-right large fade show"
         style="z-index: 2000;"
         :id="'note-modal'+state.uid"
         tabindex="-1"
         role="dialog"
         aria-hidden="true"
         >
        <div class="modal-dialog">
            <div class="modal-content w-100">
                <div class="modal-header">
                    <h5 class="modal-title"
                        style="font-size: 1.1em;">
                        Notifications
                    </h5>
                    <button type="button"
                            ref="closeModalNotification"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"></button>
                </div>

                <div class="modal-body pr-2">
                    <div class="btn-group mt-2 mb-3 w-100 d-block"
                         role="group"
                         :class="{'is-active':show_create_menu}">
                        <button 
                                @click="show_create_menu = !show_create_menu"
                                id="btnGroupDrop3" 
                                type="button" 
                                class="btn btn-outline-primary dropdown-toggle" 
                                data-bs-toggle="dropdown" 
                                aria-haspopup="true" 
                                aria-expanded="false">
                            Créer une nouvelle notification
                        </button>
                        <div class="dropdown-menu"
                             aria-labelledby="btnGroupDrop3">
                            <div class="dropdown-item"
                                 v-for="t in templates"
                                 @click="show_create_menu=false; create_notification(t.uid)">
                                {{t.subject}}
                            </div>
                        </div>
                    </div>
                    <h2 class="small-title">Historique</h2>
                    <div class="col-12 mb-5"
                         v-if="email_set.length > 0">
                        <div class="row g-0 clickable"
                             v-for="email in email_set"
                             @click="select_notification(email)"
                             :key="email.uid">
                            <div class="col-auto sw-2 d-flex flex-column justify-content-center align-items-center me-4">
                                <div class="w-100 d-flex h-100 justify-content-center position-relative">
                                    <div class="line-w-1 bg-separator h-100 position-absolute"></div>
                                </div>
                                <div class="bg-foreground sw-2 sh-2 rounded-xl shadow d-flex flex-shrink-0 justify-content-center align-items-center mt-n2 position-relative">
                                    <div class="bg-primary sw-1 sh-1 rounded-xl position-relative"></div>
                                </div>
                                <div class="w-100 d-flex h-100"></div>
                            </div>
                            <div class="col mb-2">
                                <div class="card h-100" :class="{'selected': email.uid == notification.uid}">
                                    <div class="card-body row g-0">
                                        <div class="col">
                                            <div class="card-body d-flex flex-column pe-0 pt-0 pb-0 h-100 justify-content-start">
                                                <div class="d-flex flex-column">
                                                    <div class="d-flex flex-column justify-content-center">
                                                        <a href="#" class="heading stretched-link m-0"  v-if="email.sent_on != null &amp;&amp; email.pending == false">Notification envoyée {{email.sent_on|from_now}} <span class="text-alternate small"> | Crée {{email.created_on|from_now}}</span></a>
                                                        <a href="#" class="heading stretched-link m-0"  v-if="email.sent_on != null &amp;&amp; email.pending == true">Notification mis en attente {{email.sent_on|from_now}} <span class="text-alternate small"> | Crée {{email.created_on|from_now}}</span></a>
                                                        <a href="#" class="heading stretched-link m-0"  v-if="email.sent_on == null">Nouvelle Notification <span class="text-alternate small"> | Crée {{email.created_on|from_now}}</span></a>

                                                    </div>
                                                    <div class="text-muted mt-1">{{email.subject}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p class="content is-small" v-else="v-else">Pas de notifications</p>
                    <h2 class="small-title">Message</h2>
                    <form>

                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="customCheck1" :checked="to_gathering" disabled="disabled">
                            <label class="form-check-label" for="customCheck1">Envoyer au groupement</label>
                        </div>
                        <div class="field">
                            <label class="form-check-label" v-if="establishment && establishment.batch_notifications == true">Sujet et corps pour envoi immédiat</label>
                            <input type="text" class="form-control mb-2" placeholder="Titre le l'email" :placeholder="email_type_fields.subject && email_type_fields.subject.description" v-model="notification.subject" :disabled="notification.uid == null || notification.sent_on != null">
                        </div>
                        <div class="field">
                            <textarea class="form-control" rows="6"  :placeholder="email_type_fields.body && email_type_fields.body.description" v-model="notification.body" :disabled="notification.uid == null || notification.sent_on != null"></textarea>
                        </div>

                        <div class="field" v-if="establishment && establishment.batch_notifications == true">
                            <label class="form-check-label">{{email_type_fields.batch_comment && email_type_fields.batch_comment.description}}</label>
                            <div class="control">
                                <textarea class="form-control" rows="2" :placeholder="email_type_fields.batch_comment && email_type_fields.batch_comment.description" v-model="notification.batch_comment" :disabled="notification.uid == null || notification.sent_on != null"></textarea>
                            </div>
                        </div>
                    </form>


                </div>
                <div class="modal-footer border-0">
                    <div v-if="establishment && establishment.batch_notifications">
                        <p>Envoi en lot: {{batch_days}} à minuit</p>
                    </div>
                    <div class="btn-group" role="group">
                        <button class="btn btn-primary"
                                type="button"
                                aria-label="Close"
                                :disabled="notification.sent_on != null || notification.uid == null"
                                @click="send_notification(notification.uid, true, false)"
                                v-if="establishment && establishment.batch_notifications == false">
                            Envoyer
                        </button>
                        <button class="btn btn-primary"
                                type="button"
                                aria-label="Close"
                                :disabled="notification.sent_on != null || notification.uid == null"
                                @click="send_notification(notification.uid, false, false)"
                                v-if="establishment && establishment.batch_notifications == true">
                            Envoyer en lot
                        </button>
                        
                        <button class="btn btn-primary"
                                type="button"
                                aria-label="Close"
                                :disabled="notification.sent_on != null || notification.uid == null"
                                v-if="establishment && establishment.batch_notifications"
                                @click="send_notification(notification.uid, true)">
                            Envoie Immédiat
                        </button>
                        
                        <button class="btn btn-primary"
                                type="button"
                                aria-label="Close"
                                @click="send_notification(notification.uid, true, true)"
                                v-if="establishment && establishment.batch_notifications == false" >
                            Notifier sans email
                        </button>
                        <button class="btn btn-primary"
                                type="button"
                                aria-label="Close"
                                :disabled="notification.sent_on != null || notification.uid == null"
                                @click="delete_notification(notification.uid)">
                            Supprimer
                        </button>
                        <button class="btn btn-outline-primary"
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close">
                            Fermer
                        </button>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
import tools from "@/tools.js";
import moment from "moment";
import MAIL_TEMPLATES_FROM_STATE from '@/gql/queries/mailTemplatesFromState.graphql';
import NOTIFY_WITHOUT_EMAIL from '@/gql/mutations/notifyWithoutEmail.graphql';
import EMAIL_SET from '@/gql/queries/emailSet.graphql';
import EMAIL_DELETE from '@/gql/mutations/emailDelete.graphql';
import EMAIL_UPSERT from '@/gql/mutations/emailUpsert.graphql';
import EMAIL_UPDATE_CONTENT from '@/gql/mutations/emailUpdateContent.graphql';
import EMAIL_SEND from '@/gql/mutations/emailSend.graphql';
import ESTABLISHMENT_BY_STATE from '@/gql/queries/establishmentByState.graphql';
import { gqlQuery, gqlMutation } from '@/gqlClient.js';

moment.locale("fr");

const DAYS = {
  mon: "Lundi",
  tue: "Mardi",
  wed: "Mercredi",
  thu: "Jeudi",
  fri: "Vendredi",
  sat: "Samedi",
  sun: "Dimanche"
};

const empty_notification = {
  uid: null,
  subject: null,
  body: null,
  batch_comment: null,
  sent_on: null,
  to: null
};

export default {
  name: "ReviewStateNotification",
  props: {
    state: {
      type: Object,
      required: true
    },
    to_gathering: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      templates: [],
      show_create_menu: false,
      email_set: [],
      notification: tools.deep_copy(empty_notification),
      establishment: null
    };
  },
  methods: {
    async fetch_establishment_data() {
      const response = await gqlQuery(ESTABLISHMENT_BY_STATE, { uid: this.state.uid });
      if (response.ok) {
        this.establishment = response.body.data.state.review.establishment;
      }
    },
    async fetch_data() {
      const [emailResp, templatesResp] = await Promise.all([
        gqlQuery(EMAIL_SET, { 'state__uid': this.state.uid }),
        gqlQuery(MAIL_TEMPLATES_FROM_STATE, { state_uid: this.state.uid })
      ]);
      this.email_set = emailResp.body.data.email_set || [];
      this.templates = templatesResp.body.data.email_template_set_from_state;
      this.$emit('update-email-set', JSON.parse(JSON.stringify(this.email_set)));
    },
    async send_notification(uid, asap, fake_send) {
      const self = this;
      const { allow, notify_text } = tools.check_modified_fields(self.$store);
      if (!allow) {
        self.$store.dispatch("notify", {
          text: notify_text,
          seconds: 5,
          level: "danger"
        });
        return;
      }
      if (fake_send) {
        await gqlMutation(NOTIFY_WITHOUT_EMAIL, { uid: this.state.uid, asap: true, to_gathering: this.to_gathering });
        self.$refs.closeModalNotification.click();
      } else {
        await gqlMutation(EMAIL_UPDATE_CONTENT, {
          uid,
          subject: this.notification.subject,
          body: this.notification.body,
          batch_comment: this.notification.batch_comment,
          fake_send
        });
        await gqlMutation(EMAIL_SEND, { uid, asap, to_gathering: self.to_gathering });
        this.notification = tools.deep_copy(empty_notification);
        self.$refs.closeModalNotification.click();
      }
    },
    async delete_notification(uid) {
      await gqlMutation(EMAIL_DELETE, { id: uid });
      this.notification = tools.deep_copy(empty_notification);
    },
    async create_notification(template_uid) {
      const response = await gqlMutation(EMAIL_UPSERT, { state: this.state.uid, template: template_uid });
      this.select_notification(response.body.data.email_upsert);
    },
    select_notification(data) {
      this.notification = {
        uid: data.uid,
        subject: data.subject,
        batch_comment: data.batch_comment,
        body: data.body,
        sent_on: data.sent_on,
        to: data.to
      };
    }
  },
  computed: {
    email_type_fields() {
      const models = this.$store.state.models;
      return models && models.EmailType ? models.EmailType.fields_map : {};
    },
    batch_days() {
      if (this.establishment) {
        const days = [];
        for (const day_slug of ["mon", "tue", "wed", "thu", "fri", "sat", "sun"]) {
          if (this.establishment["notify_" + day_slug]) {
            days.push(DAYS[day_slug]);
          }
        }
        return days.join(", ");
      } else {
        return "";
      }
    }
  },
  async mounted() {
    await this.fetch_data();
    await this.fetch_establishment_data();
    this.$djangows['onmodelsignals']({ modelName: "email", appLabel: "core" }, (event) => {
      if (event.obj) {
        if (event.obj.state === this.state.uid) {
          this.fetch_data();
        }
      } else {
        if (event.obj.state === this.state.uid) {
          if (event.message === "deleted") {
            this.fetch_data();
          }
        }
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.is-sent {
    background-color: #ddd
}
.selected {
    background-color: #eee;
    border-radius: 1rem !important;
    // color: red;
    // box-shadow: 1px 1px 1px black;
}
.clickable{
    cursor: pointer;
}
.card-header{
    padding:0;
}
.card{
    border-radius:0.25rem;
}
#note-modal {
  z-index: 1051 !important; 
}
.modal-content {
    overflow-y: scroll;
}
</style>
